// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './styles/global.css'; // Centralized design tokens + shared helpers (additive)
// import './index.css';
// import Preloader from "./components/Preloader";
// import App from './App';
// import FrontApp from "./FrontApp"; // Front panel
// import reportWebVitals from './reportWebVitals';
// import { CartProvider } from "./context/CartContext";

// const root = ReactDOM.createRoot(document.getElementById('root'));
// // const isAdmin = window.location.pathname.startsWith("/shreevarma/react/admin");
// const isAdmin = window.location.pathname.startsWith("/admin");
// root.render(
//   <React.StrictMode>
//    {
//    isAdmin ? <App /> :  
//    <CartProvider>
//      <Preloader />
//     <FrontApp />
//   </CartProvider>
//   }
//   </React.StrictMode>
// );


// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();




import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global.css'; // Centralized design tokens + shared helpers (additive)
import './index.css';
import Preloader from "./components/Preloader";
import App from './App';
import FrontApp from "./FrontApp"; // Front panel
import reportWebVitals from './reportWebVitals';
import { CartProvider } from "./context/CartContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
// const isAdmin = window.location.pathname.startsWith("/shreevarma/react/admin");
const isAdmin = window.location.pathname.startsWith("/admin");
root.render(
  <React.StrictMode>
   {
   isAdmin ? <App /> :  
   <CartProvider>
     <Preloader />
    <FrontApp />
  </CartProvider>
  }
  </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();